// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2C0Yi","active":"downloadDropdown_active__1RErs"};